'use client';

import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useAuthenticatedContext } from '@/app/components/Provider';
import appConst from '~/const/appConst';
import { MainColumn } from '../commons/MainColumn/MainColumn';
import { Bubble } from './svg/Bubble';
import { Bulb } from './svg/Bulb';
import { Racket } from './svg/Racket';

export const SignUpBanner = () => {
  const t = useTranslations('SIGN_UP_BANNER');
  const { redirectToLogin } = useAuthenticatedContext();

  const handleClick = async () => {
    await redirectToLogin(appConst.staticRoutes.main_criterias);
  };

  return (
    <section
      className="sign-up-banner"
      data-cy="sign-up-banner"
      data-testid="sign-up-banner"
    >
      <MainColumn>
        <div className="sign-up-banner__wrapper">
          <h2 className="vp-title-m sign-up-banner__title">
            {t('TITLE')}
          </h2>
          <ul>
            <li>
              <Racket />
              <p>{t('DESCRIPTION_1')}</p>
            </li>
            <li>
              <Bubble />
              <p>{t('DESCRIPTION_2')}</p>
            </li>
            <li>
              <Bulb />
              <p>{t('DESCRIPTION_3')}</p>
            </li>
          </ul>
          <VpButton shape="rounded" onClick={handleClick}>
            {t('CTA_LABEL')}
          </VpButton>
        </div>
      </MainColumn>
    </section>
  );
};
